/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Databases {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List Databases.
   *
   * @tags Databases
   * @name ListDatabases
   * @summary List Databases
   * @request GET:/api/databases
   * @secure
   */
  listDatabases = (params = {}) =>
    this.http.request({
      path: `/api/databases`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create Database.
   *
   * @tags Databases
   * @name CreateDatabase
   * @summary Create Database
   * @request POST:/api/databases
   * @secure
   */
  createDatabase = (data, params = {}) =>
    this.http.request({
      path: `/api/databases`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update Database.
   *
   * @tags Databases
   * @name UpdateDatabase
   * @summary Update Database
   * @request PUT:/api/databases/{database_id}
   * @secure
   */
  updateDatabase = (databaseId, data, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Database by ID.
   *
   * @tags Databases
   * @name GetDatabase
   * @summary Get Database
   * @request GET:/api/databases/{database_id}
   * @secure
   */
  getDatabase = (databaseId, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Database.
   *
   * @tags Databases
   * @name DeleteDatabase
   * @summary Delete Database
   * @request DELETE:/api/databases/{database_id}
   * @secure
   */
  deleteDatabase = (databaseId, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Create Table.
   *
   * @tags Databases
   * @name CreateTable
   * @summary Create Table
   * @request POST:/api/databases/{database_id}/tables
   * @secure
   */
  createTable = (databaseId, data, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}/tables`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Tables.
   *
   * @tags Databases
   * @name ListTables
   * @summary List Tables
   * @request GET:/api/databases/{database_id}/tables
   * @secure
   */
  listTables = (databaseId, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}/tables`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Table.
   *
   * @tags Databases
   * @name DeleteTable
   * @summary Delete Table
   * @request DELETE:/api/databases/tables/{table_id}
   * @secure
   */
  deleteTable = (tableId, params = {}) =>
    this.http.request({
      path: `/api/databases/tables/${tableId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Create View.
   *
   * @tags Databases
   * @name CreateView
   * @summary Create View
   * @request POST:/api/databases/{database_id}/views
   * @secure
   */
  createView = (databaseId, data, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}/views`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Views.
   *
   * @tags Databases
   * @name ListViews
   * @summary List Views
   * @request GET:/api/databases/{database_id}/views
   * @secure
   */
  listViews = (databaseId, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}/views`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update View.
   *
   * @tags Databases
   * @name UpdateView
   * @summary Update View
   * @request PUT:/api/databases/{database_id}/views/{view_id}
   * @secure
   */
  updateView = (databaseId, viewId, data, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}/views/${viewId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete View.
   *
   * @tags Databases
   * @name DeleteView
   * @summary Delete View
   * @request DELETE:/api/databases/{database_id}/views/{view_id}
   * @secure
   */
  deleteView = (databaseId, viewId, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}/views/${viewId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Create Record.
   *
   * @tags Databases
   * @name CreateRecord
   * @summary Create Record
   * @request POST:/api/databases/tables/{table_id}/records
   * @secure
   */
  createRecord = (tableId, data, params = {}) =>
    this.http.request({
      path: `/api/databases/tables/${tableId}/records`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Records.
   *
   * @tags Databases
   * @name ListRecords
   * @summary List Records
   * @request GET:/api/databases/tables/{table_id}/records
   * @secure
   */
  listRecords = (tableId, params = {}) =>
    this.http.request({
      path: `/api/databases/tables/${tableId}/records`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Record.
   *
   * @tags Databases
   * @name UpdateRecord
   * @summary Update Record
   * @request PUT:/api/databases/records/{record_id}
   * @secure
   */
  updateRecord = (recordId, data, params = {}) =>
    this.http.request({
      path: `/api/databases/records/${recordId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get Record by ID.
   *
   * @tags Databases
   * @name GetRecord
   * @summary Get Record
   * @request GET:/api/databases/records/{record_id}
   * @secure
   */
  getRecord = (recordId, params = {}) =>
    this.http.request({
      path: `/api/databases/records/${recordId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Record.
   *
   * @tags Databases
   * @name DeleteRecord
   * @summary Delete Record
   * @request DELETE:/api/databases/records/{record_id}
   * @secure
   */
  deleteRecord = (recordId, params = {}) =>
    this.http.request({
      path: `/api/databases/records/${recordId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Share Database Form.
   *
   * @tags Databases
   * @name ShareDatabaseForm
   * @summary Share Database Form
   * @request POST:/api/databases/{database_id}/forms/share
   * @secure
   */
  shareDatabaseForm = (databaseId, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}/forms/share`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List Form Submissions.
   *
   * @tags Databases
   * @name ListFormSubmissions
   * @summary List Form Submissions
   * @request GET:/api/databases/{database_id}/submissions
   * @secure
   */
  listFormSubmissions = (databaseId, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}/submissions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Form Submission Detail.
   *
   * @tags Databases
   * @name GetFormSubmission
   * @summary Get Form Submission
   * @request GET:/api/databases/{database_id}/submissions/{submission_id}
   * @secure
   */
  getFormSubmission = (databaseId, submissionId, params = {}) =>
    this.http.request({
      path: `/api/databases/${databaseId}/submissions/${submissionId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Accept Form Submission.
   *
   * @tags Databases
   * @name AcceptFormSubmission
   * @summary Accept Form Submission
   * @request PUT:/api/databases/submissions/{submission_id}/accept
   * @secure
   */
  acceptFormSubmission = (submissionId, params = {}) =>
    this.http.request({
      path: `/api/databases/submissions/${submissionId}/accept`,
      method: "PUT",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Return Form Submission.
   *
   * @tags Databases
   * @name ReturnFormSubmission
   * @summary Return Form Submission
   * @request PUT:/api/databases/submissions/{submission_id}/return
   * @secure
   */
  returnFormSubmission = (submissionId, data, params = {}) =>
    this.http.request({
      path: `/api/databases/submissions/${submissionId}/return`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create Column.
   *
   * @tags Databases
   * @name CreateColumn
   * @summary Create Column
   * @request POST:/api/databases/tables/{table_id}/columns
   * @secure
   */
  createColumn = (tableId, data, params = {}) =>
    this.http.request({
      path: `/api/databases/tables/${tableId}/columns`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Update Column.
   *
   * @tags Databases
   * @name UpdateColumn
   * @summary Update Column
   * @request PUT:/api/databases/columns/{column_id}
   * @secure
   */
  updateColumn = (columnId, data, params = {}) =>
    this.http.request({
      path: `/api/databases/columns/${columnId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete Column.
   *
   * @tags Databases
   * @name DeleteColumn
   * @summary Delete Column
   * @request DELETE:/api/databases/columns/{column_id}
   * @secure
   */
  deleteColumn = (columnId, params = {}) =>
    this.http.request({
      path: `/api/databases/columns/${columnId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
